import store, {types as storeTypes} from '../store'

import axios from 'axios'

import router from '../router'

import AlertModule from 'vux/src/plugins/alert/module'



/**
* config可配置参数
* [hideError=false] 隐藏出错弹窗
*/
axios.interceptors.request.use(
(config) => {
config.mask !== false && store.commit(storeTypes.UPDATE_LOADING, true)
config.mask !== false && store.commit(storeTypes.UPDATE_MASK, true)
return config
})


axios.interceptors.response.use(
(res) => {
store.commit(storeTypes.UPDATE_LOADING, false)
let {data, config} = res.response || res

config.mask !== false && store.commit(storeTypes.UPDATE_MASK, false)

if (data.serverTime) {
store.commit(storeTypes.SET_SERVER_TIME, data.serverTime)
}
return res
})


axios.interceptors.response.use(null,
(res) => {
store.commit(storeTypes.UPDATE_LOADING, false)

let {data, status, statusText, config} = res.response || res
console.log('3333',data)
config.mask !== false && store.commit(storeTypes.UPDATE_MASK, false)

if (data.serverTime) {
store.commit(storeTypes.SET_SERVER_TIME, data.serverTime)
}

if (config.handleError === false) {
return Promise.reject(res)
}

let isZyData = verifyZyData(data)
let requireAuth = status === 401 || data.errorCode === 401

switch (true) {
case requireAuth:
return auth(config, data)


case !config.hideError:
let msg = isZyData ? data.errorMsg : `${status}, ${statusText}`
if(data.data && data.data.traceId){
msg += `[${data.data.traceId}]`
}
AlertModule.show({
title: '出错了 :(',
content: msg || '未知错误',
buttonText: '知道了'
})
break;

default:

}

return new Promise(() => {
});

})

/**
* 验证是否是 zy 的规范
* @param data
* @returns {*|boolean}
*/
function verifyZyData(data) {
return data && ('success' in data)
}

/**
* 授权
* @param data
* @param config
*/
function auth(config, data) {
console.log('2222',config,data)
let from = config.from;
var route = router.currentRoute;
if (!from) {
from = route ? route.fullPath : '/login/mt';
}
if(data.errorCode !== 30006){

from = '/#' + from; 
}
console.log('from = ' + from)
router.replace({
name: data.errorCode === 30007 ? 'mt-login' : 'wx-login',
query: {from}
})
}



// WEBPACK FOOTER //
// ./src/api/interceptors.js